import { useTranslation } from "react-i18next";
import i18n from "../../../react-i18next-ex/i18next";
import a from "../public/1.png";
import b from "../public/2.png";
import c from "../public/3.png";
import d from "../public/4.png";
import f from "../public/5.png";
import handCraft1 from "../public/handMade1.png";
import handCraft2 from "../public/handMade2.png";
import handCraft3 from "../public/handMade4.png";
import twitter from "../public/twitter.svg"
import linkedin from "../public/linkedin.svg"
import instagram from "../public/instagram.svg"
import facebook from "../public/twitter.svg"


export const exploreWorlds = [
  {
    id: "world-1",
    img: a,
    title: "PersianGulf",
  },
  {
    id: "world-2",
    img: b,
    title: "MountDamavand",
  },
  {
    id: "world-3",
    img: c,
    title: "DaryaSarPlain",
  },
  {
    id: "world-4",
    img: d,
    title: "QeshmIsland",
  },
  {
    id: "world-5",
    img: f,
    title: "DashtLut",
  },
];

export const villageOptions = [
  { number: 1, option: "hajij1" },
  { number: 2, option: "hojij2" },
  { number: 3, option: "hajij3" },
];

export const handCrafts = [
  {
    img: handCraft3,
    title: "Enameling",
    subtitle: "EnamelingAbout",
  },
  {
    img: handCraft1,
    title: "Toreutics",
    subtitle: "ToreuticsAbout",
  },
  {
    img: handCraft2,
    title: "carpet",
    subtitle: "carpetAbout",
  },
];

export const socials = [
  {
    name: "twitter",
    url:twitter,
  },
  {
    name: "linkedin",
    url: linkedin,
  },
  {
    name: "instagram",
    url: instagram,
  },
  {
    name: "facebook",
    url: facebook,
  },
];
